import {FC} from 'react'
import {ChooseEmployee} from 'features/procedures/ChooseEmployee'

export const Index: FC = () => {
  return <ChooseEmployee procedureType="parental_leave_support_allowance" nextAction="request" />
}
